import React from "react";
import { withRouter } from 'react-router-dom';
import OptionButtons from "./OptionButtons";

class StartingHandBase extends React.Component {

    render() {
        return (<div>
            <OptionButtons buttonArray={[
                {
                    name: "Learn About Position", props: {
                        "data-target": "#landingPageLearnMoreModal",
                        "data-e2e" : "Learn About Position",
                        "data-toggle": "modal"
                    },
                    onclickMethod: this.props.learnMoreTrackingStartingHand
                },
                {
                    name: "View Your Hands",
                    datae2e: "View-your-hands",
                    isVisbile: this.props.play === 'ideal',
                    onclickMethod: this.props.seeMoreHands,
                    disabled: !this.props.isHandsAvailable,
                },
            ]}
            />
        </div>)
    }
}

export default withRouter(StartingHandBase);


/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/StartingHandBase.js
 **/